import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { IAddBanner } from "../../Banner.props";

const useAddBanner = () => {
  const [formData, setFormData] = useState<IAddBanner>({
    image: "",
    link: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setFormData((prevState) => ({
        ...prevState,
        image: file, // Set the file in formData
      }));
    }
  };

  const removeImage = () => {
    setFormData((prevState) => ({
      ...prevState,
      image: "", // Reset the image in formData
    }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddBanner> = async () => {
    setLoading(true);

    const formDataToSend = new FormData();

    // Append the image file or string (depending on its type) to the FormData object
    if (formData.image instanceof File) {
      formDataToSend.append("image", formData.image);
    } else {
      console.error("No valid file selected");
      toast.error("Please select an image file");
      setLoading(false);
      return;
    }

    // Append the link if provided (preserves parameters in the URL)
    if (formData.link) {
      formDataToSend.append("link", formData.link);
    }

    try {
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createBanner}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response !== "undefined") {
        toast.success("Banner added successfully", {
          duration: 10000,
        });
        navigate("/banner");
      }
    } catch (error) {
      toast.error("Error adding banner", {
        duration: 10000,
      });
      console.error("Error adding banner:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/banner");
  };

  return {
    loading,
    formData,
    handleFileChange,
    handleChange,
    handleSubmit,
    handleCancel,
    removeImage,
  };
};

export default useAddBanner;
